import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/system-manage',
    name: 'SystemManage',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/system-manage/dict-manage/list',
    meta: {
      title: 'saas系统管理'
    },
    children: [
      {
        path: 'dict-manage/list',
        name: 'SystemManageDictManageList',
        component: () => import('./dictionary-manage/view/list/index.vue'),
        meta: {
          title: '字典管理',
          auth: true,
          activeMenu: 'SystemManageDictManageList'
        },
      },
      {
        path: 'inspired-system-configuration',
        name: 'InspiredSystemConfiguration',
        redirect: '/system-manage/inspired-system-configuration/category-label-configuration',
        meta: {
          title: '灵感系统配置'
        },
        children: [
          {
            path: 'category-label-configuration',
            name: 'InspiredSystemConfigurationCategoryLabelConfiguration',
            component: () => import('./inspired-system-configuration/views/category-label-configuration/index.vue'),
            meta: {
              title: '品类关联标签',
              auth: true,
            },
          },
          {
            path: 'fabric-label-configuration',
            name: 'InspiredSystemConfigurationFabricLabelConfiguration',
            component: () => import('./inspired-system-configuration/views/fabric-label-configuration/index.vue'),
            meta: {
              title: '面料关联标签',
              auth: true,
            },
          },
          {
            path: 'aigc-label-configuration',
            name: 'InspiredSystemConfigurationAigcLabelConfiguration',
            component: () => import('./inspired-system-configuration/views/aigc-label-configuration/index.vue'),
            meta: {
              title: 'AIGC标签管理',
              auth: true,
            },
          },
        ],
      },
      {
        path: 'template-library-manage/list',
        name: 'SystemManageTemplateLibraryManage',
        component: () => import('./template-library-manage/views/list/index.vue'),
        meta: {
          title: '版型库管理',
          auth: true,
          activeMenu: 'SystemManageTemplateLibraryManage',
        },
      },
      {
        path: 'template-library-manage/create',
        name: 'SystemManageTemplateLibraryManageCreate',
        component: () => import('./template-library-manage/views/create/index.vue'),
        meta: {
          title: '版型库新增',
          auth: true,
          activeMenu: 'SystemManageTemplateLibraryManage',
        },
      },
      {
        path: 'template-library-manage/edit/:templateId',
        name: 'SystemManageTemplateLibraryManageEdit',
        component: () => import('./template-library-manage/views/create/index.vue'),
        meta: {
          title: '版型库编辑',
          auth: true,
          activeMenu: 'SystemManageTemplateLibraryManage',
        },
      },
      {
        path: 'scene-library-manage/list',
        name: 'SystemManageSceneLibraryManage',
        component: () => import('./scene-library-manage/views/list/index.vue'),
        meta: {
          title: '场景库管理',
          auth: true,
          activeMenu: 'SystemManageSceneLibraryManage',
        },
      },
      {
        path: 'scene-library-manage/create',
        name: 'SystemManageSceneLibraryManageCreate',
        component: () => import('./scene-library-manage/views/create/index.vue'),
        meta: {
          title: '新建场景库',
          auth: true,
          activeMenu: 'SystemManageSceneLibraryManage',
        },
      },
      {
        path: 'scene-library-manage/detail/:id',
        name: 'SystemManageSceneLibraryManageDetail',
        component: () => import('./scene-library-manage/views/detail/index.vue'),
        meta: {
          title: '场景库详情',
          auth: true,
          activeMenu: 'SystemManageSceneLibraryManage',
        },
      },
      {
        path: 'scene-library-manage/edit/:id',
        name: 'SystemManageSceneLibraryManageEdit',
        component: () => import('./scene-library-manage/views/detail/index.vue'),
        meta: {
          title: '编辑场景库',
          auth: true,
          activeMenu: 'SystemManageSceneLibraryManage',
        },
      },
      {
        path: 'file-manage/list',
        name: 'SystemManageFileManage',
        component: () => import('./file-manage/views/list/index.vue'),
        meta: {
          title: '上传管理',
          auth: true,
          activeMenu: 'SystemManageFileManage',
        },
      },
      {
        path: 'file-manage/detail/:id',
        name: 'SystemManageFileManageDetail',
        component: () => import('./file-manage/views/detail/index.vue'),
        meta: {
          title: '上传详情',
          auth: true,
          activeMenu: 'SystemManageFileManage',
        },
      },
      {
        path: 'model-library-manage/list',
        name: 'SystemManageModelLibraryManage',
        component: () => import('./model-library-manage/views/list/index.vue'),
        meta: {
          title: '模特库管理',
          auth: true,
          activeMenu: 'SystemManageModelLibraryManage',
        },
      },
      {
        path: 'model-library-manage/create',
        name: 'SystemManageModelLibraryManageCreate',
        component: () => import('./model-library-manage/views/create/index.vue'),
        meta: {
          title: '新建模特库',
          auth: true,
          activeMenu: 'SystemManageModelLibraryManage',
        },
      },
      {
        path: 'model-library-manage/detail/:id',
        name: 'SystemManageModelLibraryManageDetail',
        component: () => import('./model-library-manage/views/detail/index.vue'),
        meta: {
          title: '模特库详情',
          auth: true,
          activeMenu: 'SystemManageModelLibraryManage',
        },
      },
      {
        path: 'model-library-manage/edit/:id',
        name: 'SystemManageModelLibraryManageEdit',
        component: () => import('./model-library-manage/views/create/index.vue'),
        meta: {
          title: '编辑模特库',
          auth: true,
          activeMenu: 'SystemManageModelLibraryManage',
        },
      },
    ]
  }
] as IRouteConfig[];
